export interface FetchOptions {
  url: string;
  method?: string;
  headers?: { [name: string]: string };
  body?: any;
}

export class HTTPService {
  async request({ url, method = 'GET', headers = {}, body }: FetchOptions): Promise<any> {
    if (!url) {
      throw new Error(`Must specify a url to fetch`);
    }

    const response = await fetch(url, { method, headers, body: body ? JSON.stringify(body) : undefined });

    if (response.status >= 400) {
      throw response;
    }

    const text = await response.text();
    return text ? JSON.parse(text) : undefined;
  }
}



// WEBPACK FOOTER //
// ./src/support/HTTPService.ts